import React from 'react'
import styled from 'styled-components'

import LogoSrc from './gradoo.png'
const Img = styled.img`
  width: 48px;
`

const Logo = () => <Img src={LogoSrc} alt='Gradoo' />

export default Logo



// WEBPACK FOOTER //
// ./src/components/Logo/index.js